export const menuData = [
  { label: '首页', key: 'item-1', path: '/' }, // 菜单项务必填写 key
  { label: '全国门店', key: 'item-2', path: '/store' },
  {
    label: '关于淘车车',
    key: 'submenu',
    children: [
      { label: '关于淘车车', key: 'submenu-item-1', path: '/us' },
      { label: '加入我们', key: 'submenu-item-2', path: '/join' },
      { label: '联系我们', key: 'submenu-item-3', path: '/contact' },
    ],
  },
];

export function getMenuId(path, menuArr, isBig) {
  let menuKey = '';

  for (let i = 0; i < menuArr.length; i += 1) {
    const item = menuArr[i];
    if (item.children) {
      menuKey = getMenuId(path, item.children);
      if (menuKey) {
        if(isBig){
          menuKey = item.key;
        }
        break;
      }
    } else if (item.path === path) {
      menuKey = item.key;
      if (menuKey) break;
    }
  }

  return menuKey;
}
